<template>
  <svg
    :width="size"
    :height="size"
    viewBox="-10 -10 310 310"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    style="overflow: visible"
    :class="{ animating: sparkleLoop || hover }"
  >
    <!-- Top-right rectangle -->
    <path
      d="M221.7,112.8h-72.5c-7.4,0-13.4-6-13.4-13.4V51.8c0-7.4,6-13.4,13.4-13.4h72.5c7.4,0,13.4,6,13.4,13.4v47.6C235.1,106.8,229.1,112.8,221.7,112.8z"
    />
    <!-- Left tall rectangle -->
    <path
      d="M110,249.6H47.5c-7.4,0-13.4-6-13.4-13.4V52.1c0-7.4,6-13.4,13.4-13.4H110c7.4,0,13.4,6,13.4,13.4v184.1C123.4,243.6,117.4,249.6,110,249.6z"
    />
    <!-- Bottom-right circle -->
    <path
      d="M165.7,186.5L165.7,186.5c-17.9,0-32.4-14.5-32.4-32.4v0c0-17.9,14.5-32.4,32.4-32.4h0c17.9,0,32.4,14.5,32.4,32.4v0C198.1,172,183.6,186.5,165.7,186.5z"
    />

    <!-- Sparkles (always rendered; animate only when sparkleLoop or hover) -->
    <path
      class="sparkle sparkle-1"
      d="M300,-30 L311,12 L353,23 L311,34 L300,76 L289,34 L247,23 L289,12 Z"
    />
    <path
      class="sparkle sparkle-2"
      d="M290,104 L299,138 L333,147 L299,156 L290,190 L281,156 L247,147 L281,138 Z"
    />
    <path
      class="sparkle sparkle-3"
      d="M-16,220 L-9,246 L17,253 L-9,260 L-16,286 L-23,260 L-49,253 L-23,246 Z"
    />
    <path
      class="sparkle sparkle-4"
      d="M-10,-20 L0,16 L36,26 L0,36 L-10,72 L-20,36 L-56,26 L-20,16 Z"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps({
  size: {
    type: Number,
    default: 24,
  },
  /** Keep sparkles animating indefinitely (e.g. while AI is thinking) */
  sparkleLoop: {
    type: Boolean,
    default: false,
  },
  /** Animate sparkles while hovered (consumer-controlled hover state) */
  hover: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.sparkle {
  transform-box: fill-box;
  transform-origin: center;
  will-change: transform, opacity;
}

@keyframes sparkle-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.2);
    opacity: 0.2;
  }
}

.animating .sparkle-1,
.animating .sparkle-2,
.animating .sparkle-3,
.animating .sparkle-4 {
  animation: sparkle-pulse 2.2s ease-in-out infinite;
}

.animating .sparkle-2 {
  animation-delay: 0.7s;
}
.animating .sparkle-3 {
  animation-delay: 1.4s;
}
.animating .sparkle-4 {
  animation-delay: 1.1s;
}
</style>
